module.exports = __webpack_public_path__ + "img/flower_leaf_5.07fa9a8c.png";